import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '@rabbit/elements/shared-components';
import CreateNewConsumerForm from '../forms/CreateNewConsumerForm/CreateNewConsumerForm';

export interface ModalCreateNewConsumerFormProps {
  handleClose: () => void;
  onSubmit: (data: any) => void;
  data?: any;
  isLoading?: boolean;
}

export function ModalCreateNewConsumerForm({
  handleClose,
  onSubmit,
  data,
  isLoading: externalLoading,
}: ModalCreateNewConsumerFormProps) {
  const { t } = useTranslation();
  const [internalLoading, setInternalLoading] = useState(false);
  const isLoading =
    externalLoading !== undefined ? externalLoading : internalLoading;

  const handleFormChange = (nextStep: string, data: any) => {
    if (nextStep === 'add-product') {
      setInternalLoading(true);
      onSubmit(data);
    }
  };

  return (
    <Modal
      kind="generic"
      settings={{
        handleClose,
        title: t('general.createNewCustomer'),
      }}
      className="max-w-3xl"
    >
      <CreateNewConsumerForm
        handleClose={handleClose}
        onChange={handleFormChange}
        data={{ type: 'new', ...data }}
        isLoading={isLoading}
      />
    </Modal>
  );
}

export default ModalCreateNewConsumerForm;
